/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'menuuser': {
    width: 32,
    height: 32,
    viewBox: '0 0 320 320',
    data: '<g _fill="currentColor"><path pid="0" d="M20 255c0-36 6-52 25-71 38-38 65-29 84 28 9 26 19 50 23 53 4 4 14-18 23-49 14-48 20-56 41-56 40 0 64 33 64 90v50H20v-45zM100 120C47 67 110-19 182 11c45 19 54 79 16 112-27 23-73 22-98-3z"/></g>'
  }
})
